import { render, staticRenderFns } from "./white-board.vue?vue&type=template&id=794a8d3b&scoped=true&"
import script from "./white-board.vue?vue&type=script&lang=js&"
export * from "./white-board.vue?vue&type=script&lang=js&"
import style0 from "./white-board.vue?vue&type=style&index=0&id=794a8d3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794a8d3b",
  null
  
)

export default component.exports